import ManageTeamMemeberRole from "../components/ManageTeamMemberRole.vue";
import ManageAction from "../components/ManageAction.vue";
import Vue from "vue";
import Vuetify from "vuetify";
import store from "../../../store";
import router from "../../../router";

export default {
  serviceKey: "sso",
  key: "ssoTeamToInternalUser",
  name: {
    singular: "Team User",
    plural: "Team User",
    //
    ssoTeam: {
      singular: "User",
      plural: "Users",
    },
    internalUser: {
      singular: "Team",
      plural: "Teams",
    },
  },
  parents: ["ssoTeam", "internalUser"],

  apiUrls: {
    apiBrowseUrl: "",
    apiStoreUrl: "",
    apiUpdateUrl: "",
    apiReadUrl: "",
    apiMultiUpdateUrl: "",
    apiTrashedBrowseUrl: "",
    apiSoftDeleteUrl: "",
    apiHardDeleteUrl: "",
    apiRestoreUrl: "",
  },

  permissionKeys: {
    browse: "sso-ssoTeamToInternalUser-browse",
    read: "sso-ssoTeamToInternalUser-read",
    add: "sso-ssoTeamToInternalUser-add",
    edit: "sso-ssoTeamToInternalUser-edit",
    delete: "sso-ssoTeamToInternalUser-delete",
    restore: "sso-ssoTeamToInternalUser-restore",
    forceDelete: "sso-ssoTeamToInternalUser-forceDelete",
  },

  recordAccessControl: {
    browse: {
      all: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      own: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      assignedTo: {
        roles: ["salesperson", "sales-lead"],
        apiUrl: "",
      },
      belongsTo: {
        ssoBusiness: {
          roles: ["superadmin"],
          apiUrl: "",
        },
        ssoTeam: {
          roles: ["superadmin"],
          apiUrl: "",
        },
      },
    },
  },

  browse: {
    table: {
      actions: {
        manageCellEdit: true,
        columnSelectionDisabledCount: 3,
        isActionColumnVisible: true,
        isTrashedTabVisible: true,
      },
      headers: [
        {
          formatter: "rowSelection",
          titleFormatter: "rowSelection",
          titleFormatterParams: {
            rowRange: "active", //only toggle the values of the active filtered rows
          },
          hozAlign: "left",
          headerSort: false,
          filterable: false,
          searchable: false,
          selectableColumn: false,
          headerFilter: false,
          download: false,
        },

        {
          title: "Index",
          formatter: (cell) => {
            return cell.getRow().getData().rownum;
          },
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: false,
          hozAlign: "left",
          download: false,
        },

        {
          title: "Team",
          field: "SsoTeam.name",
          dataType: "string",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "left",
        },

        {
          title: "User",
          field: "InternalUser.name",
          modelKey: "string",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "left",
        },
        /*  {
          title: "User",
          field: "uuid",
          dataType: "modelParent",
          modelKey: "InternalUser",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: true,
          selectableColumn: true,
          hozAlign: "left",
        }, */

        {
          title: "Role",
          field: "isAdmin",
          dataType: "boolean",
          filterable: true,
          searchable: true,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
          formatter: (cell) => {
            // how to get the table data here
            Vue.use(Vuetify);
            let ComponentClass = Vue.extend(ManageTeamMemeberRole);
            let instance = new ComponentClass({
              propsData: {
                cellRowData: cell.getData(),
                cellValue: cell.getValue(),
                cellTableData: cell.getTable().getData(),
                ssoTeamId: cell.getRow().getData().SsoTeam.id,
              },
              vuetify: new Vuetify({}),
              store,
            });

            instance.$mount();
            return instance.$el;
          },
        },
        {
          title: "Actions",
          formatter: (cell) => {
            Vue.use(Vuetify);
            let ComponentClass = Vue.extend(ManageAction);
            let instance = new ComponentClass({
              propsData: {
                cellData: cell.getData(),
                cellValue: cell.getValue(),
                cellTableData: cell.getTable().getData(),
                cellRowData: cell.getRow().getData(),
                childModelServiceKey: "sso",
                parentModelKey: "ssoTeam",
                intermediateChildModelKey: "internalUser",
                childModelKey: "ssoTeamToInternalUser",
                modelKey: "ssoTeamToInternalUser",
                parentModelId: cell.getRow().getData().SsoTeam.id,
                intermediateModelId: cell.getRow().getData().id,
              },
              vuetify: new Vuetify({}),
              store,
              router,
            });
            instance.$mount();
            return instance.$el;
          },
        },
      ],
    },
  },
  read: false,
  add: {
    fields: [
      {
        type: "model",
        key: "internalUserUuid",
        name: "User",
        modelKey: "internalUser",
        optionText: "name",
        optionValue: "uuid",
      },
      {
        type: "model",
        key: "ssoTeamUuid",
        name: "Team",
        modelKey: "ssoTeam",
        optionText: "name",
        optionValue: "uuid",
      },

      {
        type: "boolean",
        key: "isAdmin",
        name: "Is Admin",
      },
    ],
    rules: {
      internalUserUuid: ["required"],
      ssoTeamUuid: ["required"],
    },
  },
  edit: false,
  delete: false,
};
